import React from "react";

export default function DienInIcon(color) {
    return (<svg version="1.1" id="Laag_99" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="40px" height="40px" viewBox="20 20 40 40" enableBackground="new 0 0 80 80">
        <path fill={color} d="M42.209,42.377c-0.006,0-0.012,0-0.017,0c-0.153-0.006-0.296-0.081-0.387-0.204l-5.538-7.554
        c-0.163-0.223-0.115-0.535,0.108-0.699c0.222-0.164,0.534-0.116,0.699,0.108l5.162,7.041l11.531-13.685
        c0.181-0.211,0.496-0.237,0.705-0.06c0.211,0.178,0.238,0.493,0.061,0.705L42.592,42.199C42.496,42.312,42.356,42.377,42.209,42.377
        z"/>
        <path fill={color} d="M50.585,34.486c0.85,1.659,1.339,3.532,1.339,5.52c0,6.705-5.455,12.16-12.16,12.16
        s-12.16-5.455-12.16-12.16s5.455-12.16,12.16-12.16c3.496,0,6.644,1.492,8.864,3.862l0.673-0.744c-2.4-2.53-5.783-4.118-9.537-4.118
        c-7.256,0-13.16,5.904-13.16,13.16c0,7.257,5.904,13.16,13.16,13.16c7.257,0,13.16-5.903,13.16-13.16
        c0-2.288-0.589-4.439-1.62-6.315L50.585,34.486z"/>
    </svg>
    );
}